import { useEffect, useRef, useState } from "react";

const pickMime = () => ["audio/webm;codecs=opus", "audio/webm", "audio/ogg;codecs=opus", "audio/mp4"].find((m) => window.MediaRecorder && MediaRecorder.isTypeSupported(m)) || "";
export const blobToB64 = (blob) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(blob); });

/** Petit enregistreur vocal (appui pour parler) partagé par les écrans d'urgence. */
export function useRecorder(maxSecs = 60) {
  const [rec, setRec] = useState({ state: "idle", secs: 0, blob: null, mime: "", duree: 0 });
  const recRef = useRef(null);
  const chunks = useRef([]);
  const timer = useRef(null);
  const startedAt = useRef(0);
  const supported = typeof navigator !== "undefined" && !!navigator.mediaDevices?.getUserMedia && !!window.MediaRecorder;

  const stop = () => { clearInterval(timer.current); const r = recRef.current; if (r && r.state !== "inactive") { r.stop(); r.stream.getTracks().forEach((t) => t.stop()); } };
  const start = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mime = pickMime();
    const r = new MediaRecorder(stream, mime ? { mimeType: mime } : undefined);
    chunks.current = [];
    r.ondataavailable = (e) => { if (e.data.size) chunks.current.push(e.data); };
    r.onstop = () => {
      const duree = Math.max(1, Math.round((Date.now() - startedAt.current) / 1000));
      const blob = new Blob(chunks.current, { type: r.mimeType || mime || "audio/webm" });
      setRec({ state: "done", secs: duree, blob: blob.size > 500 ? blob : null, mime: blob.type, duree });
    };
    r.start(250); recRef.current = r; startedAt.current = Date.now();
    setRec({ state: "rec", secs: 0, blob: null, mime: "", duree: 0 });
    timer.current = setInterval(() => { const s = Math.round((Date.now() - startedAt.current) / 1000); setRec((x) => ({ ...x, secs: s })); if (s >= maxSecs) stop(); }, 500);
  };
  const reset = () => setRec({ state: "idle", secs: 0, blob: null, mime: "", duree: 0 });
  useEffect(() => () => { clearInterval(timer.current); recRef.current?.stream?.getTracks().forEach((t) => t.stop()); }, []);
  return { rec, start, stop, reset, supported };
}
